import type { Response } from '~/types/api/v2'

import { useFetchWithDefaults } from '~/composables/api/useFetchWithDefaults'

import { type DocumentIdentifier, type DocumentMutationParams, getUrlById as getDocumentByIdUrl } from '../useFetchDocument'

export const useFetchDocumentAttachments = () => {
  const getUrl = (documentId: string) => `${getDocumentByIdUrl(documentId)}/attachments`
  const { post, deleteRequest } = useFetchWithDefaults()

  const create = ({
    workspaceId,
    documentId,
    payload,
  }:
  DocumentMutationParams<
    Omit<App.Data.Payloads.Documents.CreateDocumentAttachmentPayload, 'file'> & { file: File }
  >) => {
    const body = new FormData()
    body.append('file', payload.file)

    return post<Response<App.Data.Document.AttachmentData>>({
      url: getUrl(documentId),
      workspaceId,
      fetchOptions: {
        body,
      },
    })
  }

  const drop = ({
    workspaceId,
    documentId,
    attachmentId,
  }: DocumentIdentifier & { attachmentId: string }) =>
    deleteRequest({
      url: `${getUrl(documentId)}/${attachmentId}`,
      workspaceId,
    })

  return {
    create,
    drop,
  }
}
